import React, { useState } from "react";
import { checkIfNumber } from "utils/englishTool";
import FormikError from "./Errors/FormikError";

interface ITextField {
  name: string;
  placeholder?: string;
  labelText?: string;
  formik?: any;
  customValue?: any;
  customHandleChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  type?: string;
  maxChars?: number;
  isPassword?: boolean;
  leftAdornment?: any;
  rightAdornment?: any;
  disabled?: boolean;
  readOnly?: boolean;
  wrapperClassname?: string;
  onChange?: (input: any) => void;
}

function CustomTextField({
  name,
  placeholder,
  labelText,
  formik,
  customValue,
  customHandleChange,
  type,
  maxChars,
  isPassword,
  leftAdornment,
  rightAdornment,
  disabled,
  readOnly = false,
  wrapperClassname,
  onChange,
}: ITextField) {
  const [showPassword, setShowPassword] = useState(true);

  const getClassName = () => {
    if (leftAdornment && !rightAdornment) {
      return "relative";
    }
    if (isPassword && !rightAdornment) {
      return "relative control has-icons-left";
    }
    if (isPassword && rightAdornment) {
      return "relative control has-icons-left has-icons-right";
    }
    if (rightAdornment && !leftAdornment) {
      return "relative";
    }
    if (rightAdornment && leftAdornment) {
      return "relative";
    }
    if (!rightAdornment && !rightAdornment) {
      return "relative";
    }
  };

  return (
    <div className={`flex flex-col justify-center ${wrapperClassname || ""}`}>
      <div className="w-full">
        {labelText && (
          <label className="text-gray text-md mb-8 flex w-full   text-14 font-medium md:text-16 ">
            {labelText}
          </label>
        )}
        <div className={getClassName()}>
          <input
            disabled={disabled}
            autoComplete={isPassword ? "off" : undefined}
            type={isPassword && showPassword ? "password" : "text"}
            className={`
            form-control
            text-base
            m-0
            block
            h-48
            w-full
            rounded-10
            bg-clip-padding text-14 font-normal text-gray-700
            transition
            ease-in-out
            ps-12
            pe-12
            placeholder:text-14 placeholder:text-gray-B8B5B5
            ${disabled ? "cursor-not-allowed" : ""}
            ${
              readOnly
                ? "focus:border-gray-D9D9D9 focus:outline-none focus:!ring-0"
                : "focus:border-primary-main focus:bg-white focus:text-gray-700 focus:outline-none"
            }
            ${leftAdornment ? "!ps-44" : ""}
               ${rightAdornment ? "!pe-44" : ""}
            ${
              !!formik && formik.touched[name] && formik.errors[name]
                ? "border-error focus:border-error focus:!shadow-none focus:!ring-0"
                : " border    border-solid  border-gray-D9D9D9 bg-white"
            }
          `}
            placeholder={placeholder || ""}
            readOnly={readOnly}
            name={name}
            value={!!formik ? formik?.values[name] : customValue}
            onChange={(e) => {
              if (!!formik) {
                formik?.handleChange(e);
                if (onChange) {
                  onChange(e);
                }
              } else if (customHandleChange) {
                customHandleChange(e);
              }
            }}
            onBlur={(e) => {
              if (!!formik && !readOnly) {
                formik?.handleBlur(e);
              }
            }}
            onKeyPress={(e) => {
              if (maxChars) {
                if (!!formik) {
                  formik?.values[name]?.length === maxChars && e.preventDefault();
                }
              }
              if (type === "number") {
                if (!checkIfNumber(e.key)) {
                  e.preventDefault();
                }
              }
            }}
          />
          {leftAdornment && (
            <span className="absolute right-16 top-[48%] -translate-y-1/4">{leftAdornment}</span>
          )}

          {isPassword && (
            <span className="absolute left-12 top-13">
              {!showPassword ? (
                <i
                  className="icon-eye cursor-pointer text-22 text-gray-D8D8D8"
                  onClick={() => {
                    setShowPassword(true);
                  }}
                />
              ) : (
                <i
                  className="icon-eye1 cursor-pointer text-22 text-gray-D8D8D8"
                  onClick={() => {
                    setShowPassword(false);
                  }}
                />
              )}
            </span>
          )}

          {rightAdornment && <span className="icon is-right">{rightAdornment}</span>}
        </div>
      </div>

      <FormikError formik={formik} name={name} />
    </div>
  );
}

export { CustomTextField };
